import { OrderItemModelV2 } from "../service/models/orders/order_item_model";
import { TransactionDataModel } from "../service/models/trannsaction_model";
export const GetSubTotalAmt = (items: OrderItemModelV2[]) => {
  return items.reduce(
    (pv: number, item: OrderItemModelV2) =>
      pv + item.qty * (item.price + (item.extra_amt ? item.extra_amt : 0)),
    0
  );
};

export const GetTxnAmt = (transactions: TransactionDataModel[]) => {
  return transactions.reduce((pv: number, item: TransactionDataModel) => {
    return pv + item.amount;
  }, 0);
};

export const rupeeFormat = (rs: number) => {
  return rs.toLocaleString("en-IN", {
    maximumFractionDigits: 0,
    style: "currency",
    currency: "INR",
  });
};
